import React from "react";
import moment from "moment-timezone";

import { Divider } from "@mui/material";

import { grayDark } from "design-system/colors";
import {
  CalendarIcon,
  PassengerCountIcon,
  NoteIcon,
} from "design-system/icons";
import MoovsIconPanel from "components/globals/MoovsIconPanel";
import { useTimeFormat } from "globals/hooks";

type AdditionalStopInfoButtonPanelProps = {
  stopLabel: string;
  dateTime: string;
  groupSize: number;
  note: string;
  onEditAdditionalStopInfoClick: () => void;
};

function AdditionalStopInfoButtonPanel(
  props: AdditionalStopInfoButtonPanelProps
) {
  const {
    stopLabel,
    dateTime,
    groupSize,
    note,
    onEditAdditionalStopInfoClick,
  } = props;
  
  const { formatDateTime } = useTimeFormat();

  // if no additional info fields show nothing
  if (!dateTime && !note && !groupSize) {
    return null;
  }

  return (
    <>
      <MoovsIconPanel
        bottomDrawerHeader={`Additional ${stopLabel} Info`}
        onEditClick={onEditAdditionalStopInfoClick}
        items={[
          {
            icon: <CalendarIcon color={grayDark} />,
            renderItem: !!dateTime,
            mainText: `${stopLabel} Date & Time`,
            subText: formatDateTime(moment.utc(dateTime)),
          },
          {
            icon: <PassengerCountIcon color={grayDark} />,
            renderItem: groupSize >= 0 && groupSize !== null,
            mainText: "Passenger Count",
            subText: groupSize?.toString(),
          },
          {
            icon: <NoteIcon color={grayDark} />,
            renderItem: !!note,
            mainText: `${stopLabel} Note`,
            subText: note,
          },
        ]}
      />
      <Divider
        flexItem
        orientation="vertical"
        style={{ marginLeft: "16px", marginRight: "16px" }}
      />
    </>
  );
}

export default AdditionalStopInfoButtonPanel;
